module.exports = __webpack_public_path__ + "img/lens-167-minus-03.fc405e9d.png";